__turbopack_context__.v({
  "content": "DemoDayStats-module-scss-module__SEf-Ta__content",
  "iconWrapper": "DemoDayStats-module-scss-module__SEf-Ta__iconWrapper",
  "label": "DemoDayStats-module-scss-module__SEf-Ta__label",
  "root": "DemoDayStats-module-scss-module__SEf-Ta__root",
  "stat": "DemoDayStats-module-scss-module__SEf-Ta__stat",
  "value": "DemoDayStats-module-scss-module__SEf-Ta__value",
});
